import React, { useCallback, useEffect, useRef, useState } from "react";
import { FixedDonateButton, HiddenPayPalContainer } from "./styles";

declare global {
	interface Window {
		PayPal?: {
			Donation: {
				Button: (config: {
					env: string;
					hosted_button_id: string;
					image: {
						src: string;
						alt: string;
						title: string;
					};
				}) => {
					render: (selector: string) => void;
				};
			};
		};
	}
}

const PayPalDonate: React.FC = () => {
	const scriptLoaded = useRef(false);
	const containerRef = useRef<HTMLDivElement>(null);
	const [opacity, setOpacity] = useState(1);

	// Handle scroll to adjust opacity
	const handleScroll = useCallback(() => {
		const scrollY = window.scrollY;
		const maxScroll = 300; // Scroll distance for minimum opacity
		const minOpacity = 0.5;
		const newOpacity = Math.max(
			minOpacity,
			1 - (scrollY / maxScroll) * (1 - minOpacity),
		);
		setOpacity(newOpacity);
	}, []);

	useEffect(() => {
		window.addEventListener("scroll", handleScroll, { passive: true });
		return () => window.removeEventListener("scroll", handleScroll);
	}, [handleScroll]);

	useEffect(() => {
		if (scriptLoaded.current) return;

		const script = document.createElement("script");
		script.src = "https://www.paypalobjects.com/donate/sdk/donate-sdk.js";
		script.charset = "UTF-8";
		script.async = true;

		script.onload = () => {
			if (window.PayPal) {
				window.PayPal.Donation.Button({
					env: "production",
					hosted_button_id: "HQ47SMXTU99S8",
					image: {
						src: "https://www.paypalobjects.com/en_US/i/btn/btn_donateCC_LG.gif",
						alt: "Donate with PayPal button",
						title: "PayPal - The safer, easier way to pay online!",
					},
				}).render("#paypal-hidden-button");
			}
		};

		document.body.appendChild(script);
		scriptLoaded.current = true;
	}, []);

	const handleDonateClick = () => {
		// Find and click the PayPal button/link inside the hidden container
		const paypalElement = document.querySelector(
			"#paypal-hidden-button a, #paypal-hidden-button button, #paypal-hidden-button img",
		) as HTMLElement;
		if (paypalElement) {
			paypalElement.click();
		}
	};

	return (
		<>
			<HiddenPayPalContainer ref={containerRef}>
				<div id="paypal-hidden-button"></div>
			</HiddenPayPalContainer>
			<FixedDonateButton onClick={handleDonateClick} style={{ opacity }}>
				Donate
			</FixedDonateButton>
		</>
	);
};

export default PayPalDonate;
